import { isHiddenOnKiosk } from './show-on-kiosk';
/** A hidden or missing device floor cannot be a reset or navigation origin. */
export const resolveWhereAmIFloor = (location, context) => {
    var _a;
    const deviceLocationId = context === null || context === void 0 ? void 0 : context.deviceLocationId;
    const enabled = context &&
        'isWhereAmIEnabled' in context &&
        context.isWhereAmIEnabled !== null
        ? Boolean(context.isWhereAmIEnabled)
        : Boolean(deviceLocationId);
    if (!enabled || !deviceLocationId || isHiddenOnKiosk(location)) {
        return undefined;
    }
    const floor = (_a = location === null || location === void 0 ? void 0 : location.children) === null || _a === void 0 ? void 0 : _a.find((child) => child.id === deviceLocationId);
    if (!floor ||
        isHiddenOnKiosk(floor) ||
        floor.floorNumber === null ||
        floor.floorNumber === undefined ||
        !Number.isFinite(Number(floor.floorNumber))) {
        return undefined;
    }
    return floor;
};
/** Building: Where Am I or overview. Floor: default -> Where Am I -> lowest. */
export const resolveResetFloor = (location, context) => {
    var _a, _b;
    const whereAmIFloor = resolveWhereAmIFloor(location, context);
    if ((context === null || context === void 0 ? void 0 : context.viewType) !== 'floor')
        return whereAmIFloor;
    const visibleFloors = ((_a = location === null || location === void 0 ? void 0 : location.children) !== null && _a !== void 0 ? _a : []).filter((floor) => !isHiddenOnKiosk(floor));
    const preferredFloor = (_b = visibleFloors.find((floor) => floor.id === (context === null || context === void 0 ? void 0 : context.defaultFloorId))) !== null && _b !== void 0 ? _b : whereAmIFloor;
    if (preferredFloor)
        return preferredFloor;
    return [...visibleFloors].sort((a, b) => {
        const numberA = Number(a.floorNumber);
        const numberB = Number(b.floorNumber);
        return ((Number.isFinite(numberA) ? numberA : Infinity) -
            (Number.isFinite(numberB) ? numberB : Infinity));
    })[0];
};
